import { render, staticRenderFns } from "./NotificationToggle.vue?vue&type=template&id=dbeabed6&scoped=true&lang=pug"
import script from "./NotificationToggle.vue?vue&type=script&lang=js"
export * from "./NotificationToggle.vue?vue&type=script&lang=js"
import style0 from "./NotificationToggle.vue?vue&type=style&index=0&id=dbeabed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbeabed6",
  null
  
)

export default component.exports